var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuQuestionGenerator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5938 1.00098H4.375C3.6125 1.00098 2.88123 1.30388 2.34207 1.84304C1.8029 2.38221 1.5 3.11348 1.5 3.87598V26.876C1.5 27.6385 1.8029 28.3697 2.34207 28.9089C2.88123 29.4481 3.6125 29.751 4.375 29.751H21.625C22.3875 29.751 23.1188 29.4481 23.6579 28.9089C24.1971 28.3697 24.5 27.6385 24.5 26.876V8.90723L16.5938 1.00098Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 12.9307C10.4125 12.3557 10.8437 11.7807 11.4187 11.4932C12.0141 11.149 12.709 11.0184 13.3887 11.123C14.0683 11.2276 14.6919 11.561 15.1562 12.0682C15.5875 12.6432 15.875 13.2182 15.875 13.937C15.875 15.8057 13 16.812 13 16.812M13 22.562H13.0144",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuQuestionGenerator);
export default __webpack_public_path__ + "static/media/menu-question-generator.548c77f51335171572dbd03414ee882c.svg";
export { ForwardRef as ReactComponent };